import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

interface SwitchProps extends React.InputHTMLAttributes<HTMLInputElement> {
  name: string;
  id: string;
  uncheckedLabel?: React.ReactNode;
  checkedLabel?: React.ReactNode;
}

const SwitchComponent: React.ForwardRefRenderFunction<HTMLInputElement, SwitchProps> = (
  { name, id, uncheckedLabel, checkedLabel, ...inputProps },
  ref
) => {
  const { t } = useTranslation();
  return (
    <label htmlFor={id} data-testid={`${name}-label`} className="flex cursor-pointer items-center">
      <input
        type="checkbox"
        name={name}
        id={id}
        data-testid={`${name}-input`}
        className="peer -z-10 h-0 w-0 opacity-0"
        ref={ref}
        {...inputProps}
      />
      <div
        data-testid={`${name}-switch`}
        className={`
        relative flex h-9 w-[280px] items-center justify-around rounded-full border-2 border-primaryExtraLight text-primary
        before:absolute before:left-0 before:z-0 before:flex before:h-9 before:w-[50%]
        before:items-center before:justify-center before:rounded-full before:bg-primaryExtraLight before:transition-all before:duration-200
        before:peer-checked:left-auto before:peer-checked:translate-x-[50%]
      `}
      >
        <div data-testid={`${name}-label-unchecked`} className="z-10">
          {uncheckedLabel ?? t('depot_stocks.answer_no')}
        </div>
        <div data-testid={`${name}-label-checked`} className="z-10">
          {checkedLabel ?? t('depot_stocks.answer_yes')}
        </div>
      </div>
    </label>
  );
};

export const Switch = forwardRef(SwitchComponent);
